<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'900px'"
    :classDialog="'create-dialog'"
    :offsetTop="'3vh'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    :appendToBody="true"
    :modalAppendToBody="true"
  >
    <template #body>
      <h3 class="dialogTitle margin-bottom-0">
        Cập nhật thông tin ban hành trục liên thông văn bản
      </h3>
      <div class="blkDocCreation">
        <div :class="['form-info']">
          <el-form
            ref="form"
            :model="form"
            :rules="validationRules"
            inline-message
          >
            <el-form-item
              class="input-no__label input-header__docs margin-top-10"
              prop="quote"
            >
              <el-input
                type="textarea"
                :row="3"
                autosize
                v-focus="true"
                :resize="'none'"
                v-model="form.quote"
                placeholder="* Trích yếu văn bản"
                maxlength="2000"
                size="large"
                class="input-font__bold style-fullWidth docBigTitle"
                :disabled="true"
              />
            </el-form-item>
            <div class="group__info padding-bottom-10">
              <div class="title font-size__medium">
                Thông tin văn bản
              </div>
              <div class="content">
                <!-- <div class="label font-size__medium"></div> -->
                <div class="form-input">
                  <!--người ký duyệt-->
                  <el-form-item
                    class="custom-label__input"
                    prop="signerUserDeptRoleId"
                  >
                    <span class="label-input field-needed"
                    >Người ký duyệt
                    </span>
                    <multiselect
                      :options="signerUserDeptRoles"
                      :class="[
                        'style-fullWidth input-font__bold',
                        'input-border__radius__0'
                      ]"
                      label="fullName"
                      track-by="id"
                      v-model="signerUserDeptRole"
                      :custom-label="signerLabel"
                      placeholder="Chọn người ký duyệt"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :allow-empty="true"
                      :searchable="true"
                      @select="signer => signerUserDeptRolesChanged(signer)"
                      @remove="() => signerUserDeptRolesChanged(null)"
                    >
                      <template slot="noResult"
                      >Không tìm thấy dữ liệu phù hợp.
                      </template>
                      <template slot="noOptions"
                      >Danh sách trống
                      </template>
                      <template slot="singleLabel" slot-scope="{ option }">
                        <div
                          class="flex-row flex__left padding-right-10 inline-block"
                        >
                          <span class="font-weight__bold">{{
                            option.fullName
                          }}</span>
                          ({{ option.positionName + " - " + option.deptName }})
                        </div>
                      </template>
                    </multiselect>
                  </el-form-item>
                  <!--văn bản quy phạm pháp luật-->
                  <el-form-item class="custom-label__input">
                    <span class="label-input">Văn bản quy phạm pháp luật</span>
                    <el-checkbox
                      :border="false"
                      v-model="form.isLawDocument"
                      class="style-fullWidth has-border__bottom"
                    ></el-checkbox>
                  </el-form-item>
                  <!--loại chỉ đạo-->
                  <el-form-item
                    class="custom-label__input margin-top-10"
                    prop="steeringTypeId"
                  >
                    <span :class="['label-input', 'field-needed']"
                    >Loại chỉ đạo</span
                    >
                    <el-select
                      clearable
                      class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                      v-model="form.steeringTypeId"
                      filterable
                      placeholder="-"
                    >
                      <el-option
                        v-for="item in steeringTypes"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>

          <div class="el-dialog__footer">
            <div class="flex-row flex__left form-button__action">
              <el-button
                class="dialogBtnPrimary"
                @click="update()"
                :disabled="isProcessing"
              >
                <i
                  :class="[!isProcessing ? 'fas fa-save' : 'el-icon-loading']"
                ></i>
                &nbsp;Hiệu chỉnh
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
  import handleRequestErrorMixin from "../handleRequestErrorMixin";
  import convertToLabelFilter from "../../filters/convertToLabelFilter";
  import uploadFileMixin from "../doc-in/uploadFileMixin";
  import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
  import constants from "../../constants";
  import errorMessageFilter from "../../filters/errorMessageFilter";
  import CustomDialog from "../common/custom-dialog";
  import outgoingDocService from "../../services/outgoingDocService";
  import userDeptRoleViewService from "../../services/userDeptRoleViewService";

  export default {
    name: "update-tltvb-required-data-dialog",
    mixins: [handleRequestErrorMixin, uploadFileMixin, vbAttachmentTokenMixin],
    props: ["isOpen", "docId"],
    filters: {convertToLabelFilter},

    components: {
      CustomDialog,
      Multiselect: () => import("vue-multiselect")
    },

    data() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };

      return {
        form: {
          quote: null,
          isLawDocument: null,
          steeringTypeId: null,
          signerUserDeptRoleId: null,
        },
        validationRules: {
          steeringTypeId: [defaultRequiredConstrains],
          signerUserDeptRoleId: [defaultRequiredConstrains],
        },
        steeringTypes: null,
        isProcessing: null,
        signerUserDeptRoles: [],
        signerUserDeptRole: null,
      };
    },

    computed: {},

    watch: {},

    created() {
      this.initSteeringTypes();
      this.loadOutgoingDoc()
        .then(() => this.bindDataToForm())
        .then(() => this.loadSignerUserDeptRoles());
    },

    methods: {

      loadSignerUserDeptRoles() {
        return userDeptRoleViewService
          .findAllSignerForCreateKyNgoai(this.outgoingDoc.publisherId, {
            sort: "createTime,desc"
          })
          .then(response => (this.signerUserDeptRoles = (response.data || [])));
      },

      signerUserDeptRolesChanged(signer) {
        this.form.signerUserDeptRoleId = signer ? signer.id : null;
        this.$nextTick(() =>
          this.$refs.form.validateField("signerUserDeptRoleId")
        );
      },

      signerLabel(signer) {
        return `${signer.fullName} (${signer.positionName} - ${signer.deptName})`;
      },

      loadOutgoingDoc() {
        return outgoingDocService.findById(this.docId).then(response => {
          this.outgoingDoc = response.data;
        });
      },

      bindDataToForm() {
        this.form.quote = this.outgoingDoc.quote;
        this.form.isLawDocument =
          this.outgoingDoc.isLawDocument === constants.TRUE;
        this.form.steeringTypeId = this.outgoingDoc.steeringType;
      },

      initSteeringTypes() {
        this.steeringTypes = [
          {
            id: constants.STEERING_TYPE.KHONGPHAICHIDAO,
            name: errorMessageFilter({
              errorCode: "steeringType.label.khongphaichidao"
            })
          },
          {
            id: constants.STEERING_TYPE.CHIDAO,
            name: errorMessageFilter({
              errorCode: "steeringType.label.chidao"
            })
          },
          {
            id: constants.STEERING_TYPE.BAOCAOCHIDAO,
            name: errorMessageFilter({
              errorCode: "steeringType.label.baocaochidao"
            })
          }
        ];
      },

      convertToSubmitForm() {
        return {
          isLawDocument: this.form.isLawDocument
            ? constants.TRUE
            : constants.FALSE,
          steeringTypeId: this.form.steeringTypeId,
          signerUserDeptRoleId: this.form.signerUserDeptRoleId
        };
      },

      update() {
        this.validateForm().then(() => {
          this.isProcessing = true;
          return outgoingDocService
            .updateTltvbData(this.docId, this.convertToSubmitForm())
            .then(response => {
              this.isProcessing = false;
              this.$message({
                message: '"Cập nhật thông tin thành công"',
                type: "success",
                duration: 2000
              });
              this.$emit("success", {doc: (this.outgoingDoc = response.data)});
            })
            .catch(error => {
              this.isProcessing = false;
              this.commonHandleRequestError(error);
              throw error;
            });
        });
      },

      validateForm() {
        return new Promise(resolve => {
          this.$refs.form.validate(valid => {
            valid
              ? resolve()
              : this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
          });
        });
      }
    }
  };
</script>
<style scoped>
  .el-input__inner {
    padding: 0 !important;
  }

  .dialog-body .display-list__selected .list-selected .body {
    padding: 0;
  }

  .filter {
    margin: 24px 0 12px;
  }

  .filter .item {
    cursor: pointer;
    height: 40px;
    padding: 8px;
    position: relative;
    padding-left: 8px;
    background: let(--color-light);
    font-size: 12px;
    transition: let(--transition-regular);
    margin-right: 4px;
    z-index: 5;
  }

  .filter .item:nth-child(2) {
    z-index: 4;
  }

  .filter .item:nth-child(3) {
    z-index: 3;
  }

  .filter .item:nth-child(4) {
    z-index: 2;
  }

  .filter .item:nth-child(5) {
    z-index: 1;
  }

  .filter .item:after {
    content: "";
    top: 0;
    position: absolute;
    border-bottom: 20px solid transparent;
    border-top: 20px solid transparent;
    height: 0px;
    width: 0px;
    right: -12px;
    border-left: 12px solid let(--color-light);
    z-index: 10;
    transition: let(--transition-regular);
  }

  .filter .item:not(:first-child):before {
    content: "";
    top: 0;
    position: absolute;
    border-bottom: 20px solid transparent;
    border-top: 20px solid transparent;
    height: 0px;
    width: 0px;
    left: 0;
    border-left: 12px solid #fff;
    z-index: 10;
    transition: let(--transition-regular);
  }

  .filter .item.active {
    background-color: let(--color-blue);
    color: white;
    transition: all 0.25s;
    /* z-index: 10; */
  }

  .filter .item.active:after {
    border-left: 12px solid let(--color-blue);
  }

  .filter .item:not(:first-child) {
    padding-left: 20px;
  }

  .filter .item:first-child {
    border-radius: 4px 0 0 4px;
  }

  .filter .item:last-child {
    /*border-radius: 0 4px 4px 0;*/
    padding-right: 16px;
  }

  .filter .item .index {
    width: 24px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin-right: 4px;
    font-size: 12px;
    color: let(--color-dark);
  }

  .filter .item.active .index {
    background-color: white;
  }

  .check-list {
    width: 295px;
  }

  .cell.el-tooltip {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-out/update-tltvb-required-data-dialog.vue